// below code is used to show and hide the 'add to cart' bar component.
// As the user scrolls and the element mainCartAddButton steps outside of the viewport, the ATCBar will change its display style from none to flex
const mainCartAddButton = document.querySelector('.product-form__submit');
const atcbar = document.querySelector('.add-to-cart-bar');
const stickyATCObserver = new window.IntersectionObserver(
  ([entry]) => {
    if (window.scrollY <= entry.boundingClientRect.bottom || entry.isIntersecting) {
      atcbar.style.display = 'none';

      // Move the chat icon back
      if (typeof(rep) === 'object' && typeof(rep.config) === 'function') {
        if (window.innerWidth < 990) {
          rep.config({
            "widgetPosition": {
              "p": "CUSTOM",
              "cp": {
                "x": "25px",
                "y": "25px",
                "h": "RIGHT",
                "v": "BOTTOM"
              }
            }
          });
        } else {
          rep.config({
            "widgetPosition": {
              "p": "CUSTOM",
              "cp": {
                "x": "25px",
                "y": "25px",
                "h": "RIGHT",
                "v": "BOTTOM"
              }
            }
          });
        }
      }
    } else {
      atcbar.style.display = 'flex';

      // Move the chat icon
      if (typeof(rep) === 'object' && typeof(rep.config) === 'function') {
        if (window.innerWidth < 990) {
          rep.config({
            "widgetPosition": {
              "p": "CUSTOM",
              "cp": {
                "x": "25px",
                "y": "155px",
                "h": "RIGHT",
                "v": "BOTTOM"
              }
            }
          });
        } else {
          rep.config({
            "widgetPosition": {
              "p": "CUSTOM",
              "cp": {
                "x": "25px",
                "y": "110px",
                "h": "RIGHT",
                "v": "BOTTOM"
              }
            }
          });
        }
      }
    }
  },
  {
    root: null,
    threshold: 0.1,
  }
);
if (mainCartAddButton) stickyATCObserver.observe(mainCartAddButton);
